import React from 'react'
import './Fouthsection.css'
//import programskillimg  from '../images/programskillimg.png' 

function Fouthsection() {
    return (
        
        <div>
        <div className="" id="topContainer4">
        <div className="container">
        <div className="col-md-6 box" id="myskills">
        <h2 id="myskillshead">My Skills</h2>
        <p className="content4">
        "We have a passion for brainstorming ideas and facilitating discussions. We 
have a passion for creating things that make a difference for those who use 
them—and those who create them. Oddly enough, we’re most proud when 
something we create is so good that people don’t realize how good it is!
And, of course, we have empathy." - RUSS UNGER
        </p>
        </div>
        
     
       
      {/* <div className="" id="programskillimg">
      <img src={programskillimg}
    height="auto" width="100%" alt=""/></div>  */}
   

         <div className="" id="programskill">
            <div className="skillstype1"> <p className="skillstypehead"> Soft Skills </p> 
            <p className="skillstypetext" > Communication, Collaboration, Creative thinking, Detail oriented, Problem solving, Active listening, 
            Interpersonal skills.</p>
            </div>
            <div className="skillstype2"> <p className="skillstypehead"> Technical Skills </p> 
            <p className="skillstypetext"> 
            User Experience Design, User Interface 
            Design, UX Research, Usability Testing, 
            Information Architecture, Interaction 
            Design, Personas, 
            Storyboards, Graphic Design, 
            Wireframes, User Journeys, 
            Visual Design, Prototypes, 
            Mockups, Visual 
            Identity. </p>
            </div>
            <div className="skillstype3"> <p className="skillstypehead"> Software </p>
            <p className="skillstypetext"> Adobe Creative Suite, Adobe Photoshop, 
            Adobe Illustrator, Adobe XD, Figma, 
            Sketch, Invision, Protopie, Axure, Indesign,
            Cinema 4D, VS Code, Zeplin, Maze, 
            UserZoom, Hotjar, Microsoft Word, 
            Microsoft Powerpoint, Microsoft Excel.
             </p>
              </div>

              <div className="skillstype4"> <p className="skillstypehead"> Front-End </p>
            <p className="skillstypetext"> HTML/CSS, Jquery, JavaScript, React 
            JS, Bootstrap, Material UI, GitHub.
             </p>
              </div>
            </div> 

        
        </div>
        </div>
        </div>
    )
}

export default Fouthsection
